module.exports = __webpack_public_path__ + "img/bus-partner-img8.a88f5eef.png";